// @flow

import type { StaffGroupsState } from "./types";

export const onGetClientStaffGroupsSuccess = (state: StaffGroupsState) => ({
  payload,
}: Object) => ({
  ...state,
  error: null,
  list: payload,
});

export const onGetClientStaffGroupsError = (state: StaffGroupsState) => ({ payload }: Object) => ({
  ...state,
  error: payload,
});
